{
  "_comments_for_translators": "Brazilian Portuguese (pt-BR), informal 'você' register. Soybean farmer audience. Rules a future translator MUST preserve: (1) Technical tokens NDVI and Sentinel-2 stay as-is in all languages — DO NOT translate. (2) The product term 'stall' (a learned UI term in en/el) is rendered consistently as 'estagnação' here — pick one and stick with it. The alternative 'parada de crescimento' was considered and rejected for being verbose. (3) Plain-language driver labels (DO NOT use index acronyms like NDRE/PSRI etc.): biomass = 'densidade do dossel'; chlorophyll = 'verdor das folhas'; water = 'umidade'; senescence = 'envelhecimento precoce'; structure = 'estrutura do dossel'. (4) 'field' = 'talhão' (the term Brazilian soybean farmers actually use; agronomists may say 'gleba' but 'talhão' is the farmer word). (5) Preserve every {placeholder} marker EXACTLY as in en.json — key names and braces are load-bearing. (6) Greenness/vegetation health where the en/el original says 'NDVI mean' or similar stays as 'NDVI' (the user explicitly approved keeping the acronym). LLM translation pass — agronomist review pending; see docs/i18n_agronomist_review.md.",
  "sidebar.navigationLabel": "Navegação principal",
  "sidebar.themeToggleLight": "Mudar para o modo claro",
  "sidebar.themeToggleDark": "Mudar para o modo escuro",
  "nav.main": "Seções principais",
  "welcome.mapAria": "Mapa interativo de limites do talhão",
  "welcome.locating": "Localizando você...",
  "welcome.drawButtonAria": "Desenhar um novo limite de talhão",
  "welcome.drawingHintKeyboard": "Pressione Esc para cancelar o desenho.",
  "welcome.drawingLiveArea": "Área estimada: {area}",
  "welcome.drawingHintTouch": "Toque para colocar pontos. Toque no primeiro ponto para fechar.",
  "welcome.drawingHintTouchPan": "Use dois dedos para mover o mapa.",
  "welcome.drawingToolbarAria": "Ferramentas de desenho",
  "welcome.undoVertexAria": "Desfazer último ponto",
  "welcome.finishPolygonAria": "Fechar polígono e concluir desenho",
  "welcome.cancelDrawingAria": "Cancelar desenho",
  "welcome.undo": "Desfazer",
  "welcome.finish": "Concluir",
  "advisor.inputAria": "Pergunte ao consultor",
  "advisor.runSelectLabel": "Selecione uma simulação salva",
  "advisor.deleteRun": "Excluir simulação salva",
  "advisor.confirmDeleteRun": "Excluir esta simulação salva?",
  "advisor.runDeleted": "Simulação salva excluída.",
  "satellite.ndviChartAria": "Gráfico de série temporal NDVI",
  "satellite.ndviMean": "NDVI médio",
  "field.dialogTitle": "Salvar Novo Talhão",
  "field.dialogArea": "Área estimada: {size}",
  "field.dialogName": "Nome do talhão",
  "field.dialogNamePlaceholder": "Digite um nome para o talhão",
  "field.dialogCrop": "Cultura",
  "field.dialogSaving": "Salvando...",
  "field.dialogSave": "Salvar Talhão",
  "kpi.groupLabel": "Resumo de desempenho do talhão",
  "kpi.ariaYield": "Produtividade estimada {value}",
  "kpi.ariaProfit": "Lucro estimado {value}",
  "kpi.ariaHealth": "Saúde do talhão {value}",
  "kpi.ariaCaptured": "Última imagem capturada {value}",
  "sidebar.title": "AGROPTIMIZER",
  "sidebar.subtitle": "Sistema de Inteligência de Talhões",
  "sidebar.lightMode": "Modo Claro",
  "sidebar.darkMode": "Modo Escuro",
  "sidebar.logout": "Sair",
  "sidebar.drawField": "+ Desenhar Novo Talhão",
  "sidebar.yourFields": "Seus Talhões",
  "sidebar.yourFieldsAria": "Abrir lista de talhões",
  "sidebar.units.imperial": "Imperial",
  "sidebar.units.metric": "Métrico",
  "sidebar.sessionLanguage": "Idioma",
  "sidebar.sessionUnits": "Unidades de Medida",
  "common.retry": "Tentar novamente",
  "common.close": "Fechar",
  "common.cancel": "Cancelar",
  "prefs.unitsLabel": "Unidades de Medida",
  "prefs.languagePlaceholder": "Selecione o idioma",
  "prefs.unitsPlaceholder": "Selecione as unidades",
  "prefs.language.english": "English (US)",
  "prefs.language.greek": "Ελληνικά",
  "prefs.language.portuguese": "Português (Brasil)",
  "prefs.language.spanish": "Español",
  "prefs.required": "Escolha o idioma e as unidades de medida antes de continuar.",
  "params.title": "Configuração da Simulação",
  "params.fieldConditions": "Condições do Talhão",
  "params.irrigation": "Irrigação",
  "params.irrigation.rainfed": "Sequeiro",
  "params.irrigation.irrigated": "Irrigado",
  "params.prevCrop": "Cultura Anterior",
  "params.prevCrop.corn": "Milho",
  "params.prevCrop.soybean": "Soja",
  "params.prevCrop.wheat": "Trigo",
  "params.prevCrop.rice": "Arroz",
  "params.prevCrop.cotton": "Algodão",
  "params.prevCrop.fallow": "Pousio",
  "params.prevCrop.sorghum": "Sorgo",
  "params.prevCrop.otherCereal": "Outro Cereal",
  "params.prevCrop.otherLegume": "Outra Leguminosa",
  "params.prevCrop.smallGrains": "Cereais de Inverno",
  "params.prevCrop.other": "Outra",
  "params.soilType": "Tipo de Solo",
  "params.soilType.siltLoam": "Franco-Siltoso",
  "params.soilType.sandyLoam": "Franco-Arenoso",
  "params.soilType.clayLoam": "Franco-Argiloso",
  "params.soilType.siltyClayLoam": "Franco-Argilo-Siltoso",
  "params.soilType.loamySand": "Areia Franca",
  "params.soilType.loam": "Franco",
  "params.soilType.clay": "Argila",
  "params.soilType.sand": "Areia",
  "params.soilType.silt": "Silte",
  "params.soilType.sandyClayLoam": "Franco-Argilo-Arenoso",
  "params.soilType.siltyClay": "Argilo-Siltoso",
  "params.soilType.muck": "Solo Orgânico",
  "params.soilOM": "MO do Solo (%)",
  "params.soilPH": "pH do Solo",
  "params.phosphorus": "Fósforo",
  "params.phosphorus.high": ">50 ppm",
  "params.phosphorus.medium": "36–50 ppm",
  "params.phosphorus.low": "25–35 ppm",
  "params.phosphorus.veryLow": "<25 ppm",
  "params.potassium": "Potássio",
  "params.potassium.high": ">175 ppm",
  "params.potassium.medium": "131–175 ppm",
  "params.potassium.low": "61–130 ppm",
  "params.potassium.veryLow": "<61 ppm",
  "params.management": "Estratégia de Manejo",
  "params.plantMonth": "Mês do Plantio",
  "params.month.january": "Janeiro",
  "params.month.february": "Fevereiro",
  "params.month.march": "Março",
  "params.month.april": "Abril",
  "params.month.may": "Maio",
  "params.month.june": "Junho",
  "params.month.july": "Julho",
  "params.month.august": "Agosto",
  "params.month.september": "Setembro",
  "params.month.october": "Outubro",
  "params.month.november": "Novembro",
  "params.month.december": "Dezembro",
  "params.plantDay": "Dia",
  "params.maturityGroup": "Grupo de Maturação",
  "params.relativeMaturity": "Maturação Relativa (dias)",
  "params.seedingRate": "Densidade de Semeadura ({unit})",
  "params.rowSpacing": "Espaçamento de Linhas ({unit})",
  "params.tillage": "Sistema de Preparo do Solo",
  "params.tillage.conventional": "Convencional",
  "params.tillage.noTill": "Plantio Direto",
  "params.tillage.stripTill": "Cultivo em Faixas",
  "params.foliarFungicide": "Fungicida Foliar",
  "params.seedTreatment": "Tratamento de Sementes",
  "params.foliarFert": "Fertilizante Foliar",
  "params.coverCrop": "Cultura de Cobertura",
  "params.apply": "Aplicar",
  "params.no": "Não",
  "params.fertility": "Fertilidade Aplicada",
  "params.nitrogen": "Nitrogênio ({unit})",
  "params.nitrogenSplit": "Parcelamento de Nitrogênio ({unit})",
  "params.nitrogenTotal": "Total:",
  "params.nitrogenSplitNote": "O N total entre todas as aplicações não pode exceder {max} lb/ac — ajustar um controle limitará os outros.",
  "params.cornTotalNExceeded": "O nitrogênio total {total} lb/ac excede o máximo de {max} lb/ac. Reduza um dos parcelamentos de N antes de executar.",
  "params.nPreSpring": "N Pré-Primavera",
  "params.nAtPlant": "N no Plantio",
  "params.nPostPlant": "N Pós-Plantio",
  "params.phosphorusRate": "Fósforo ({unit})",
  "params.potassiumRate": "Potássio ({unit})",
  "params.sulfurRate": "Enxofre ({unit})",
  "params.economics": "Economia",
  "params.soybeanPrice": "Preço de referência EUA (NASS) — soja ({unit})",
  "params.cornPrice": "Preço de referência EUA (NASS) — milho ({unit})",
  "params.seedCostSoy": "Custo de Sementes ($/140k)",
  "params.seedCostCorn": "Custo de Sementes ($/80k)",
  "params.fixedCosts": "Custos Fixos ({unit})",
  "params.fixedCosts.tooltip": "Custos gerais por acre não atrelados a um insumo específico — p. ex. arrendamento, seguro agrícola, maquinário, mão de obra, combustível, manutenção.",
  "params.seedTreatmentCost": "Tratamento de Sementes ({unit})",
  "params.coverCropSeed": "Sementes de Cobertura ({unit})",
  "params.dryingCost": "Custo de Secagem ({unit})",
  "params.fertPrices": "Preços de Fertilizantes ({unit})",
  "params.fertNitrogen": "Nitrogênio",
  "params.fertPhosphorus": "Fósforo",
  "params.fertPotassium": "Potássio",
  "params.fertSulfur": "Enxofre",
  "params.operations": "Operações ({unit})",
  "params.convTillage": "Preparo Convencional",
  "params.noTillPlanting": "Plantio Direto",
  "params.stripTillCost": "Cultivo em Faixas",
  "params.applications": "Aplicações ({unit})",
  "params.fungInsectApp": "Fungicida/Inseticida Foliar + Aplicação",
  "params.fertApp": "Aplicação de Fertilizante",
  "params.foliarFertApp": "Fertilizante Foliar + Aplicação",
  "params.saveEcon": "Salvar Padrões Econômicos",
  "params.runSim": "Executar Simulação",
  "params.running": "Executando...",
  "params.working": "Processando...",
  "tabs.advisor": "Consultor",
  "tabs.satellite": "Monitoramento",
  "welcome.title": "Nenhum Talhão Selecionado",
  "welcome.description": "Desenhe um limite de talhão no mapa de satélite abaixo, ou selecione um talhão existente na barra lateral para iniciar sua análise.",
  "welcome.drawBtn": "Desenhar Novo Talhão",
  "advisor.chatPlaceholder": "Pergunte ao agrônomo — maximizar lucro, ranquear fatores de produtividade, comparar sistemas de preparo...",
  "advisor.send": "Enviar",
  "advisor.welcome": "Olá! Sou seu **Agrônomo IA**. Configure os parâmetros no painel à direita e execute uma simulação para começar. Posso ajudá-lo a maximizar a produtividade, otimizar o lucro ou avaliar o risco em diferentes cenários climáticos. Ou abra a aba **Monitoramento** para configurar o acompanhamento do talhão e identificar problemas cedo.",
  "advisor.engineStarting": "🚜 **Iniciando o motor...** Isso normalmente leva 2–3 minutos.",
  "advisor.paramsInvalid": "Parâmetros inválidos — ajuste e tente novamente.",
  "advisor.simResults": "**📊 Resultados da Simulação**\n\nAvaliados **{n_scenarios}** cenários em **{n_weather_years}** anos climáticos.\n\n{'|'} Métrica {'|'} Valor {'|'}\n{'|'}---{'|'}---{'|'}\n{'|'} Produtividade Média Estimada {'|'} **{yield_value}** {'|'}\n{'|'} Lucro Estimado {'|'} **{profit_value}** {'|'}\n{'|'} Margem por Bushel {'|'} **{margin_value}** {'|'}\n\nPergunte como interpretar esses resultados, maximizar o lucro ou ranquear os principais fatores de produtividade.",
  "advisor.simFailed": "❌ Simulação falhou: {error}",
  "simulation.completeToast": "Simulação para '{field}' concluída — {yield}",
  "simulation.failedToast": "Simulação para '{field}' falhou.",
  "advisor.modifyInputs": "Modificar Parâmetros",
  "advisor.hideInputs": "Ocultar Parâmetros",
  "advisor.avg": "média",
  "advisor.noRuns": "Nenhuma simulação ainda",
  "satellite.range": "intervalo",
  "satellite.insightAria": "Resumo de saúde do talhão",
  "satellite.insight.iconLabel": "Saúde",
  "satellite.insight.firstImage": "Primeira imagem da safra — vamos acompanhar mudanças nas próximas passagens.",
  "satellite.insight.noStall": "Nenhuma estagnação detectada — o sinal de vegetação do seu talhão ficou estável desde a última imagem clara.",
  "satellite.insight.flagged": "{pct}% do talhão mostra crescimento estagnado desde a imagem anterior. As manchas sinalizadas aparecem em vermelho no mapa — avalie a área afetada e a localização antes de decidir se vale ir a campo.",
  "satellite.insight.askAdvisor": "Perguntar ao Consultor sobre esta imagem",
  "advisor.autoPrompt.imageAnalysis": "Analise a imagem de satélite de {date} (DAP {dap}). O que mudou desde a imagem anterior e o que devo observar?",
  "advisor.autoPrompt.imageAnalysisNoDap": "Analise a imagem de satélite de {date}. O que mudou desde a imagem anterior e o que devo observar?",
  "advisor.autoPrompt.firstImageAnalysis": "Esta é a primeira imagem de satélite da safra para este talhão, de {date} (DAP {dap}). Quais indicadores de referência devo acompanhar daqui em diante e o que devo observar nesta imagem?",
  "advisor.autoPrompt.firstImageAnalysisNoDap": "Esta é a primeira imagem de satélite da safra para este talhão, de {date}. Quais indicadores de referência devo acompanhar daqui em diante e o que devo observar nesta imagem?",
  "satellite.state.noField.title": "Selecione um talhão para começar",
  "satellite.state.noField.body": "Desenhe ou abra um talhão em Seus Talhões para ver o monitoramento por satélite.",
  "satellite.state.awaitingFirstImage.title": "Monitoramento ativo — aguardando a primeira imagem",
  "satellite.state.awaitingFirstImage.body": "Aguardando a próxima passagem do Sentinel-2. Sua primeira imagem deve chegar em até 5 dias após a data de início do monitoramento, se o céu estiver limpo. Passagens com nuvens são ignoradas, então pode demorar mais em períodos nublados.",
  "satellite.state.monitoringActive.firstImageNote": "Primeira imagem recebida. Teremos uma leitura de tendência após a próxima passagem clara.",
  "satellite.state.seasonComplete.title": "Safra concluída",
  "satellite.state.seasonComplete.body": "Sua janela de monitoramento terminou. Revise a safra abaixo, ou planeje a próxima no Consultor.",
  "satellite.state.seasonComplete.cta": "Planejar próxima safra",
  "satellite.envelope.preCanopy": "Cobertura inicial — alguns índices ainda não estão ativos. A cobertura de detecção é reduzida até o fechamento do dossel (em torno de DAP 30).",
  "satellite.envelope.lateLimited": "Final de safra — detecção reduzida. Alguns índices já fecharam suas janelas; a ausência de alerta aqui não garante ausência de estresse.",
  "satellite.tooltip.stall.firstImage": "Primeira imagem — sem tendência ainda",
  "satellite.tooltip.stall.none": "Sem estagnação de crescimento",
  "satellite.tooltip.stall.pct": "Estagnação de crescimento: {pct}% do talhão",
  "satellite.stallRegionsCaption": "Regiões com estagnação de crescimento",
  "satellite.kpi.stall.firstImage": "Aguardando tendência",
  "satellite.kpi.stall.none": "Sem estagnação",
  "satellite.kpi.stall.flagged": "Estagnação detectada",
  "satellite.monitoringTitle": "Monitoramento do Talhão",
  "satellite.monitoringSubtitle": "Escolha sua janela de exploração. A exploração começa no mínimo 25 dias após o plantio. Você verá novas imagens e análises conforme ficarem disponíveis nesse período.",
  "satellite.monitoringPlantingDate": "Data de plantio: {date}",
  "satellite.editPlantingDateAria": "Editar data de plantio",
  "satellite.plantingDateSaveFailed": "Não foi possível salvar a nova data de plantio. Tente novamente.",
  "satellite.monitoringRangeLabel": "Janela de exploração (dias após o plantio)",
  "satellite.monitoringStartLabel": "Início da exploração (dias após o plantio)",
  "satellite.monitoringEndLabel": "Fim da exploração (dias após o plantio)",
  "satellite.monitoringStartDate": "Início: {date}",
  "satellite.monitoringEndDate": "Fim: {date}",
  "satellite.monitoringWindowSummary": "Janela de monitoramento: {start} - {end} ({days} dias)",
  "satellite.monitoringLockedSummary": "O monitoramento está bloqueado para este talhão até o fim da janela de exploração.",
  "satellite.endAdjustLabel": "Ajustar fim da janela de monitoramento",
  "satellite.endAdjustHint": "A data de plantio e o início da janela estão bloqueados porque a primeira imagem de satélite já foi capturada. Você ainda pode mover o fim da janela para frente ou para trás (até 95 dias do início).",
  "satellite.endAdjustSaving": "Salvando...",
  "satellite.endAdjustSaved": "Janela atualizada.",
  "satellite.endAdjustFailed": "Não foi possível atualizar o fim da janela. Tente novamente.",
  "satellite.monitoringStartBtn": "Iniciar Monitoramento",
  "satellite.stopMonitoringBtn": "Parar Monitoramento",
  "satellite.stopMonitoringConfirmBody": "Parar as verificações diárias por satélite para este talhão? As imagens já capturadas permanecem no histórico. Você pode iniciar uma nova safra mais tarde.",
  "satellite.stopMonitoringConfirm": "Parar Monitoramento",
  "satellite.stopMonitoringSuccess": "Monitoramento parado para este talhão.",
  "satellite.stopMonitoringFailed": "Não foi possível parar o monitoramento. Tente novamente.",
  "satellite.monitoringSeasonEnded": "Esta safra terminou. Ajuste a data de plantio e a janela acima, depois inicie uma nova safra.",
  "satellite.startNewSeason": "Iniciar Nova Safra",
  "satellite.monitoringNotStarted": "Monitoramento Não Iniciado",
  "satellite.monitoringScheduled": "Monitoramento Agendado",
  "satellite.monitoringComplete": "Monitoramento Concluído",
  "satellite.monitoringMissingPlanting": "Escolha uma data de plantio no Consultor primeiro.",
  "satellite.latestImage": "Imagem Mais Recente",
  "satellite.dayAfterPlanting": "Dia {dap} após o plantio",
  "satellite.cloudCover": "Cobertura de nuvens",
  "satellite.ndviScale": "NDVI",
  "satellite.monitoringActive": "Monitoramento Ativo",
  "satellite.connecting": "Conectando ao satélite...",
  "satellite.nextImage.one": "Próxima imagem em {days} dia ({date})",
  "satellite.nextImage.other": "Próxima imagem em {days} dias ({date})",
  "ndvi.preEmergence": "Pré-Emergência",
  "toast.error": "Erro",
  "toast.warning": "Aviso",
  "toast.success": "Pronto",
  "toast.info": "Info",
  "help.title": "GUIA AGROPTIMIZER",
  "help.placeholder": "Pergunte como usar o aplicativo...",
  "help.send": "Enviar",
  "help.greeting": "Olá! Sou seu guia AGROPTIMIZER.\n\nPosso ajudar com:\n• Como desenhar um talhão\n• O que cada aba mostra\n• Como executar uma simulação\n• Como entender as imagens de satélite\n• Qualquer outra dúvida sobre a plataforma\n\nNo que você precisa de ajuda?",
  "login.title": "AGROPTIMIZER",
  "login.subtitle": "Inteligência de Talhões",
  "login.tabLogin": "Entrar",
  "login.tabRegister": "Cadastrar",
  "login.email": "E-mail",
  "login.emailPlaceholder": "voce{'@'}exemplo.com",
  "login.password": "Senha",
  "login.passwordPlaceholder": "••••••••",
  "login.loginBtn": "Entrar",
  "login.forgotPassword": "Esqueceu a senha?",
  "login.loggingIn": "Entrando...",
  "login.loginFailed": "Falha ao entrar",
  "register.email": "E-mail",
  "register.emailPlaceholder": "voce{'@'}exemplo.com",
  "register.password": "Senha",
  "register.passwordPlaceholder": "Mín. 8 caracteres",
  "register.confirmPassword": "Confirmar Senha",
  "register.confirmPlaceholder": "Repita a senha",
  "register.createBtn": "Criar Conta",
  "register.creating": "Criando conta...",
  "register.passwordMismatch": "As senhas não conferem",
  "register.failed": "Falha no cadastro",
  "forgot.description": "Digite seu e-mail e enviaremos um link de redefinição.",
  "forgot.email": "E-mail",
  "forgot.emailPlaceholder": "voce{'@'}exemplo.com",
  "forgot.sendBtn": "Enviar Link de Redefinição",
  "forgot.backToLogin": "← Voltar para Entrar",
  "forgot.sending": "Enviando...",
  "forgot.sendFailed": "Falha ao enviar e-mail de redefinição. Tente novamente.",
  "forgot.linkSent": "Link de redefinição enviado.",
  "changePassword.title": "Alterar Senha",
  "changePassword.currentPassword": "Senha Atual",
  "changePassword.currentPlaceholder": "••••••••",
  "changePassword.newPassword": "Nova Senha",
  "changePassword.newPlaceholder": "Mín. 8 caracteres",
  "changePassword.confirmPassword": "Confirmar Nova Senha",
  "changePassword.confirmPlaceholder": "Repita a nova senha",
  "changePassword.changeBtn": "Alterar Senha",
  "changePassword.passwordMismatch": "As senhas não conferem",
  "changePassword.saving": "Salvando...",
  "changePassword.success": "Senha alterada! Redirecionando...",
  "changePassword.failed": "Falha ao alterar senha",
  "validation.password.tooShort": "A senha deve ter pelo menos 12 caracteres.",
  "validation.password.tooLong": "A senha deve ter no máximo 72 caracteres.",
  "validation.password.common": "Esta senha está entre as mais vazadas. Escolha algo mais único — uma frase curta funciona bem.",
  "validation.password.weak": "A senha não é forte o suficiente.",
  "validation.password.criterion.length": "Pelo menos 12 caracteres",
  "validation.password.criterion.notCommon": "Não é uma senha comum",
  "validation.password.show": "Mostrar senha",
  "validation.password.hide": "Ocultar senha",
  "error.auth.invalidCredentials": "E-mail ou senha inválidos",
  "error.auth.incorrectPassword": "A senha atual está incorreta",
  "error.auth.deleteConfirmationMismatch": "Digite EXCLUIR (em letras maiúsculas) para confirmar.",
  "error.auth.externalAuth": "Esta conta usa autenticação externa",
  "success.auth.accountDeleted": "Conta excluída.",
  "success.auth.subscriptionCancelled": "Assinatura cancelada.",
  "login.passwordRequired": "Senha obrigatória",
  "deleteAccount.title": "Excluir Conta",
  "deleteAccount.warning": "Isso excluirá sua conta. Seus talhões, monitoramento por satélite, simulações e histórico de chat serão mantidos por 30 dias caso você mude de ideia, e depois removidos permanentemente. Faça login novamente em até 30 dias para cancelar a exclusão.",
  "deleteAccount.typeToConfirm": "Digite EXCLUIR para confirmar",
  "deleteAccount.deleteBtn": "Excluir Minha Conta",
  "deleteAccount.deleting": "Excluindo...",
  "deleteAccount.failed": "Não foi possível excluir a conta.",
  "cancelSubscription.title": "Cancelar Assinatura",
  "cancelSubscription.body": "Seu plano voltará para o nível gratuito. Você pode reassinar a qualquer momento e manterá seus talhões e histórico.",
  "cancelSubscription.keepPlan": "Manter Meu Plano",
  "cancelSubscription.confirmBtn": "Confirmar Cancelamento",
  "cancelSubscription.cancelling": "Cancelando...",
  "cancelSubscription.success": "Assinatura cancelada.",
  "cancelSubscription.failed": "Não foi possível cancelar a assinatura.",
  "changePassword.samePassword": "Sua nova senha precisa ser diferente da atual.",
  "changePassword.weakPassword": "A senha não é forte o suficiente.",
  "account.title": "Minha Conta",
  "account.backToHome": "← Voltar ao Início",
  "account.navLabel": "Seções da conta",
  "account.nav.profile": "Perfil",
  "account.nav.security": "Segurança",
  "account.nav.billing": "Pagamento",
  "account.nav.dangerZone": "Zona de Risco",
  "account.profile.lede": "Os dados básicos da sua conta. As preferências de sessão são definidas no login.",
  "account.profile.email": "E-mail",
  "account.profile.language": "Idioma",
  "account.profile.units": "Unidades",
  "account.profile.plan": "Plano",
  "account.profile.unitsImperial": "Imperial (acres, bu/ac)",
  "account.profile.unitsMetric": "Métrico (ha, kg/ha)",
  "account.profile.planFree": "Gratuito",
  "account.profile.languageChangeNote": "Escolha o idioma que você quer para o aplicativo, os e-mails e o consultor de IA. A mudança vale na hora.",
  "account.profile.languageChangedToast": "Idioma atualizado.",
  "account.profile.languageChangeFailedToast": "Não foi possível alterar seu idioma. Tente novamente.",
  "account.security.lede": "Atualize sua senha. Alterar a senha desconectará você dos outros dispositivos.",
  "account.billing.lede": "Seu plano de assinatura atual.",
  "account.billing.paidDescription": "Você tem acesso completo aos recursos de monitoramento e consultoria.",
  "account.billing.freeDescription": "Acesso básico. Faça upgrade para monitoramento estendido e consultoria.",
  "account.billing.freeLede": "Você está no plano gratuito.",
  "account.billing.cancelCopy": "Voltar para o plano gratuito. Você pode fazer upgrade novamente a qualquer momento.",
  "account.dangerZone.lede": "Ações irreversíveis. Confira duas vezes antes de confirmar.",
  "account.dangerZone.deleteDescription": "Agenda sua conta para exclusão permanente. Você tem 30 dias para restaurar entrando em contato com o suporte.",
  "account.nav.connections": "Contas Conectadas",
  "account.connections.lede": "Faça login mais rápido conectando um provedor de identidade externo.",
  "account.connections.linked": "Conectado",
  "account.connections.notLinked": "Não conectado",
  "account.connections.linkGoogle": "Conectar Google",
  "account.connections.unlinkGoogle": "Desconectar Google",
  "account.connections.requiresVerifiedEmail": "Verifique seu e-mail antes de conectar uma conta Google.",
  "account.connections.linkSuccessToast": "Google conectado com sucesso.",
  "account.connections.unlinkSuccessToast": "Google desconectado.",
  "account.connections.linkDialog.title": "Conectar sua conta Google",
  "account.connections.linkDialog.body": "Confirme sua senha para iniciar a conexão da sua conta Google. Você será redirecionado ao Google para conceder acesso.",
  "account.connections.linkDialog.password": "Senha atual",
  "account.connections.linkDialog.continue": "Continuar para o Google",
  "account.connections.linkDialog.linking": "Conectando...",
  "account.connections.linkDialog.failed": "Não foi possível iniciar a conexão com o Google. Tente novamente.",
  "account.connections.unlinkDialog.title": "Desconectar Google",
  "account.connections.unlinkDialog.titleEmail": "Confirmar por e-mail",
  "account.connections.unlinkDialog.bodyHybrid": "Confirme sua senha para desconectar o Google da sua conta. Você continuará entrando com e-mail e senha.",
  "account.connections.unlinkDialog.bodyGoogleOnly": "Enviaremos um link de confirmação para seu e-mail. Clique nele para definir uma nova senha e desconectar o Google. Sem uma senha você perderia o acesso à sua conta.",
  "account.connections.unlinkDialog.password": "Senha atual",
  "account.connections.unlinkDialog.confirm": "Desconectar",
  "account.connections.unlinkDialog.disconnecting": "Desconectando...",
  "account.connections.unlinkDialog.sendEmail": "Enviar e-mail de confirmação",
  "account.connections.unlinkDialog.sending": "Enviando...",
  "account.connections.unlinkDialog.emailSentToast": "Enviamos um link de confirmação para seu e-mail.",
  "account.connections.unlinkDialog.failed": "Não foi possível desconectar o Google. Tente novamente.",
  "account.connections.finalize.title": "Defina uma senha e desconecte o Google",
  "account.connections.finalize.body": "Defina uma senha para sua conta. Vamos desconectar o Google na mesma etapa.",
  "account.connections.finalize.newPassword": "Nova senha",
  "account.connections.finalize.confirmPassword": "Confirmar nova senha",
  "account.connections.finalize.confirm": "Desconectar Google",
  "account.connections.finalize.submitting": "Desconectando...",
  "account.connections.finalize.mismatch": "As senhas não coincidem.",
  "account.connections.finalize.weak": "A senha é muito fraca.",
  "account.connections.finalize.failed": "Não foi possível desconectar o Google. Tente novamente.",
  "common.cancel": "Cancelar",
  "login.oauthOr": "ou",
  "login.signInWithGoogle": "Entrar com Google",
  "login.emailVerifiedToast": "E-mail verificado — obrigado!",
  "login.emailVerifyFailedToast": "O link de verificação é inválido ou expirou. Faça login para solicitar um novo.",
  "login.oauthError.cancelled": "Login com Google foi cancelado.",
  "login.oauthError.state": "A sessão de login expirou ou é inválida. Tente novamente.",
  "login.oauthError.token": "Não foi possível concluir o login com Google. Tente novamente.",
  "login.oauthError.deactivated": "Esta conta foi desativada.",
  "login.oauthError.emailConflict": "Já existe uma conta com este e-mail. Entre com e-mail/senha e conecte o Google nas configurações.",
  "login.oauthError.googleUnverified": "O e-mail da sua conta Google não foi verificado. Verifique-o com o Google primeiro.",
  "login.oauthError.alreadyLinked": "Esta conta Google já está conectada a outra conta AGROPTIMIZER.",
  "login.oauthError.linkToken": "A sessão de conexão expirou ou é inválida. Confirme sua senha novamente.",
  "login.oauthError.linkUnauthenticated": "Faça login antes de conectar uma conta Google.",
  "login.oauthError.linkTarget": "Não encontramos sua conta. Entre novamente e tente outra vez.",
  "login.oauthError.generic": "Não foi possível entrar com Google. Tente novamente.",
  "emailVerify.banner.text": "Enviamos um link de verificação para seu e-mail. Verifique seu endereço para desbloquear a conexão de contas.",
  "emailVerify.banner.resend": "Não recebeu? Reenviar",
  "emailVerify.banner.sending": "Enviando...",
  "emailVerify.banner.sent": "Enviado — verifique sua caixa de entrada",
  "emailVerify.banner.dismiss": "Dispensar",
  "emailVerify.banner.resentToast": "E-mail de verificação enviado. Verifique sua caixa de entrada.",
  "emailVerify.banner.resendFailed": "Não foi possível enviar o e-mail de verificação. Tente novamente em alguns instantes.",
  "errors.notFound": "Os dados solicitados não foram encontrados.",
  "errors.server": "O servidor não conseguiu concluir esta solicitação. Tente novamente.",
  "units.imperial.area": "ac",
  "units.imperial.yield": "bu/ac",
  "units.imperial.nutrient": "lb/ac",
  "units.imperial.seedingRate": "k/ac",
  "units.imperial.rowSpacing": "in",
  "units.imperial.costPerArea": "$/ac",
  "units.imperial.precipitation": "in",
  "units.imperial.temperature": "°F",
  "units.imperial.pricePerBu": "$/bu",
  "units.imperial.pricePerLb": "$/lb",
  "units.metric.area": "ha",
  "units.metric.yield": "kg/ha",
  "units.metric.nutrient": "kg/ha",
  "units.metric.seedingRate": "k/ha",
  "units.metric.rowSpacing": "cm",
  "units.metric.costPerArea": "$/ha",
  "units.metric.precipitation": "mm",
  "units.metric.temperature": "°C",
  "units.metric.pricePerBu": "$/t",
  "units.metric.pricePerLb": "$/kg",
  "crop.corn": "Milho",
  "crop.soybean": "Soja",
  "error.auth.registrationFailed": "Falha no cadastro. Verifique seus dados ou tente outro e-mail.",
  "error.auth.invalidRefreshToken": "Token de atualização inválido ou expirado",
  "error.auth.invalidTokenType": "Tipo de token inválido",
  "error.auth.invalidToken": "Token de atualização inválido",
  "error.auth.userNotFound": "Usuário não encontrado",
  "error.auth.tokenRevoked": "O token foi revogado",
  "error.auth.resetLinkInvalid": "O link de redefinição é inválido ou expirou.",
  "error.field.notFound": "Talhão não encontrado",
  "error.field.tooLarge": "Talhão muito grande ({acres} acres). O máximo permitido é {max_acres} acres por talhão.",
  "error.job.notFound": "Tarefa não encontrada",
  "error.job.notCancelable": "Tarefa com status {status} não pode ser cancelada.",
  "error.sim.fieldNotFound": "Talhão não encontrado",
  "error.sim.tooManyJobs": "Muitas tarefas em andamento ({count}). Aguarde as tarefas atuais terminarem.",
  "error.sim.resultNotFound": "Resultado da simulação não encontrado",
  "error.ndvi.fieldNotFound": "Talhão não encontrado",
  "error.ndvi.cooldown": "Capturado há {days_since}d. O Sentinel-2 revisita a cada ~5 dias — próxima captura disponível {next_date}.",
  "error.ndvi.invalidDate": "Formato de data inválido. Use AAAA-MM-DD.",
  "error.ndvi.imageNotAvailable": "Imagem indisponível para esta data.",
  "error.ndvi.imageCleanedUp": "O arquivo de imagem foi removido.",
  "error.ndvi.invalidMonitoringDays": "Os dias de monitoramento devem estar entre {min_days} e {max_days}.",
  "error.market.fieldNotFound": "Talhão não encontrado",
  "error.market.contractNotFound": "Contrato não encontrado",
  "error.llm.fieldNotFound": "Talhão não encontrado ou acesso negado.",
  "error.llm.threadNotFound": "Conversa não encontrada ou acesso negado.",
  "error.llm.helpUnavailable": "Chat de ajuda temporariamente indisponível.",
  "error.rateLimit.tooMany": "Muitas requisições. Aguarde um minuto.",
  "error.rateLimit.auth": "Muitas tentativas. Aguarde um minuto.",
  "success.auth.passwordChanged": "Senha alterada com sucesso",
  "success.auth.loggedOut": "Sessão encerrada com sucesso",
  "success.auth.resetLinkSent": "Se o e-mail estiver cadastrado, um link de redefinição foi enviado.",
  "success.auth.passwordReset": "Senha redefinida com sucesso. Você já pode entrar.",
  "success.ndvi.jobInProgress": "Já existe uma análise por satélite em andamento para este talhão.",
  "success.ndvi.monitoringStopped": "Monitoramento interrompido com sucesso.",
  "success.ndvi.noMonitoring": "Nenhum monitoramento ativo encontrado.",
  "success.market.refreshQueued": "Todas as tarefas de busca de dados de mercado e AMS foram enfileiradas com sucesso.",
  "status.job.started": "Iniciada",
  "status.job.complete": "Concluída",
  "status.job.retryingGeneric": "Tentando novamente",
  "status.job.failedGeneric": "A tarefa falhou. Tente novamente.",
  "status.ndvi.noImagery": "Nenhuma imagem clara encontrada na janela recente.",
  "common.unknown": "Desconhecido",
  "fields.loading": "Carregando talhões...",
  "fields.empty": "Nenhum talhão ainda. Desenhe um limite para criar um.",
  "fields.rename": "Renomear",
  "fields.delete": "Excluir",
  "fields.renamePrompt": "Digite um novo nome para este talhão:",
  "fields.deleteConfirm": "Tem certeza que deseja excluir \"{name}\"?",
  "kpi.estYield": "Produt. Est.",
  "kpi.estProfit": "Lucro Est.",
  "kpi.fieldHealth": "Saúde do Talhão",
  "kpi.lastCaptured": "Última Captura",
  "kpi.growthSignal": "Sinal de crescimento",
  "kpi.today": "Hoje",
  "kpi.dayAgo": "1 dia atrás",
  "kpi.daysAgo": "{n} dias atrás",
  "kpi.ariaBreakeven": "Margem de equilíbrio {value}",
  "kpi.marginTooltip": "Margem por bushel é o que você ganha em cada bushel depois de cobrir os custos. É o preço da cultura menos o preço de equilíbrio. O preço de equilíbrio é o custo total por acre dividido pela produtividade esperada.",
  "advisor.you": "Você",
  "advisor.replyUnavailable": "Desculpe, não consegui gerar uma resposta.",
  "advisor.replyFailed": "Desculpe, algo deu errado ao gerar a resposta. Tente novamente.",
  "advisor.replyError": "Desculpe, ocorreu um erro. Tente novamente.",
  "satellite.condition": "Condição",
  "satellite.daysAfterPlantingShort": "DAP",
  "satellite.ndviUpdatedNudge": "Imagens de satélite atualizadas para este talhão. Última observação: vigor da vegetação={mean}, condição=\"{label}\". Pergunte qualquer coisa sobre a saúde da cultura ou tendências de vigor.",
  "help.open": "Abrir ajuda",
  "help.errorReply": "Desculpe, algo deu errado. Tente novamente.",
  "login.success": "Sessão iniciada com sucesso.",
  "register.success": "Conta criada com sucesso.",
  "market.breakeven.margin": "Margem",
  "common.maxShort": "Máx",
  "simulation.submitting": "Enviando simulação...",
  "simulation.running": "Executando simulação...",
  "simulation.loadingResults": "Carregando resultados...",
  "satellite.noField": "Nenhum Talhão Selecionado",
  "satellite.today": "Hoje",
  "satellite.oneDayAgo": "1 dia atrás",
  "satellite.daysAgo": "{n} dias atrás",
  "satellite.monitoringWaitHint": "O monitoramento carregará as imagens automaticamente quando uma nova passagem estiver disponível.",
  "home.title": "Seus Talhões",
  "home.subtitle": "Qual talhão precisa de atenção?",
  "home.mapTitle": "Mapa de talhões",
  "home.mapAriaLabel": "Mapa geral dos seus talhões",
  "home.lastObserved": "Última imagem {date}",
  "home.noObservation": "Sem observação ainda",
  "home.status.stall_detected": "Estagnação detectada — abra o mapa para conferir {area} sinalizada(s) desde a imagem anterior",
  "home.status.on_track": "A saúde da cultura parece boa",
  "home.status.monitoring_active": "Monitoramento ativo — aguardando dados de tendência",
  "home.status.stale": "Sem imagem clara há {n} dias — volte a verificar em breve",
  "home.status.no_observations": "Aguardando a primeira imagem de satélite",
  "home.status.low_confidence": "Imagem recente parcialmente nublada — visão limitada",
  "home.empty.title": "Adicione seu primeiro talhão para começar",
  "home.empty.subtitle": "Desenhe um limite no mapa de satélite para criar um talhão.",
  "home.empty.action": "Criar Talhão",
  "home.loading": "Carregando talhões...",
  "home.loadError": "Não foi possível carregar os talhões. Tente novamente.",
  "home.newField": "+ Novo Talhão",
  "home.totalArea": "Total: {area} em {n} talhões",
  "field.created": "Talhão criado com sucesso",
  "field.createFailed": "Falha ao criar talhão",
  "welcome.drawingHint": "Clique no mapa para colocar vértices. Clique no primeiro ponto para fechar o polígono.",
  "login.invalidEmail": "Formato de e-mail inválido",
  "login.lockedOut": "Tente novamente em {seconds}s",
  "satellite.growthFromPrevToSelected": "Crescimento de {prev} até {selected}",
  "satellite.ndviTimeSeries": "Série Temporal NDVI",
  "sidebar.toggle": "Alternar menu",
  "common.yes": "Sim",
  "params.foliarFertAppCost": "Aplicação de Fertilizante Foliar",
  "advisor.sidebar.title": "Conversas",
  "advisor.sidebar.aria": "Conversas",
  "advisor.sidebar.sims": "Simulações",
  "advisor.sidebar.images": "Imagens",
  "advisor.sidebar.untitled": "Simulação sem título",
  "advisor.sidebar.untitledSeason": "Temporada sem título",
  "advisor.sidebar.rename": "Renomear",
  "advisor.sidebar.delete": "Excluir",
  "advisor.sidebar.confirmDelete": "Excluir?",
  "advisor.sidebar.empty": "Rode uma simulação ou clique em «Pergunte ao Consultor sobre esta imagem» para iniciar uma conversa.",
  "advisor.relTime.justNow": "agora mesmo",
  "advisor.relTime.minutesAgo": "há {n}m",
  "advisor.relTime.hoursAgo": "há {n}h",
  "advisor.relTime.daysAgo": "há {n}d",
  "advisor.divider.simFallback": "Simulação",
  "advisor.divider.imageFallback": "Imagem",
  "advisor.inputGate.preData": "Rode uma simulação ou clique em «Pergunte ao Consultor sobre esta imagem» para iniciar uma conversa.",
  "advisor.openRail": "Abrir conversas",
  "reset.description": "Defina uma nova senha para sua conta.",
  "reset.newPassword": "Nova senha",
  "reset.confirmPassword": "Confirme a nova senha",
  "reset.confirmPlaceholder": "Repita a nova senha",
  "reset.submit": "Definir nova senha",
  "reset.submitting": "Atualizando...",
  "reset.success": "Senha atualizada. Faça login com sua nova senha.",
  "reset.failed": "Não foi possível redefinir a senha. O link pode ter expirado — solicite um novo.",
  "reset.tokenMissing": "O link de redefinição está faltando ou é inválido. Solicite um novo.",
  "validation.password.criteriaLabel": "Requisitos de senha"
}
